var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternet1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.0829C76.1632 3.08119 86.8368 3.08119 95.5 8.0829L138.081 32.6671C146.744 37.6688 152.081 46.9124 152.081 56.9158V106.084C152.081 116.088 146.744 125.331 138.081 130.333L95.5 154.917C86.8368 159.919 76.1632 159.919 67.5 154.917L24.9189 130.333C16.2557 125.331 10.9189 116.088 10.9189 106.084V56.9158C10.9189 46.9124 16.2557 37.6688 24.9189 32.6671L67.5 8.0829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13.3301C77.641 10.6506 83.359 10.6506 88 13.3301L135.787 40.9199C140.428 43.5994 143.287 48.5513 143.287 53.9103V109.09C143.287 114.449 140.428 119.401 135.787 122.08L88 149.67C83.359 152.349 77.641 152.349 73 149.67L25.2132 122.08C20.5721 119.401 17.7132 114.449 17.7132 109.09V53.9103C17.7132 48.5513 20.5721 43.5994 25.2132 40.9199L73 13.3301Z",
    fill: "url(#paint0_linear_170_11663)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16.7528C78.0222 14.4306 82.9778 14.4306 87 16.7528L133.323 43.4972C137.345 45.8195 139.823 50.1111 139.823 54.7556V108.244C139.823 112.889 137.345 117.181 133.323 119.503L87 146.247C82.9778 148.569 78.0222 148.569 74 146.247L27.6773 119.503C23.655 117.181 21.1773 112.889 21.1773 108.244V54.7556C21.1773 50.1111 23.655 45.8195 27.6773 43.4972L74 16.7528Z",
    fill: "url(#paint1_linear_170_11663)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7255 95.4492C75.2199 95.4492 70.7408 99.9284 70.7408 105.434C71.2428 118.662 90.2103 118.658 90.7102 105.434C90.7102 99.9283 86.231 95.4492 80.7255 95.4492ZM83.7126 108.421C83.1876 108.946 82.3364 108.946 81.8113 108.421L80.7255 107.335L79.6396 108.421C79.1145 108.946 78.2633 108.946 77.7383 108.421C77.2132 107.896 77.2132 107.045 77.7383 106.52L78.8242 105.434L77.7383 104.348C77.2132 103.823 77.2132 102.972 77.7383 102.447C78.2633 101.922 79.1145 101.922 79.6396 102.447L80.7255 103.533L81.8113 102.447C82.3364 101.922 83.1876 101.922 83.7126 102.447C84.2377 102.972 84.2377 103.823 83.7126 104.348L82.6268 105.434L83.7126 106.52C84.2377 107.045 84.2377 107.896 83.7126 108.421Z",
    fill: "url(#paint2_linear_170_11663)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1885 93.8961C97.5908 100.777 107.861 90.5224 100.976 83.1086C89.8351 71.9677 71.7718 71.9677 60.6309 83.1086C57.652 86.0875 57.652 90.9172 60.6309 93.8961C63.6098 96.875 68.4395 96.875 71.4184 93.8961C76.6015 88.7128 85.0052 88.7128 90.1885 93.8961Z",
    fill: "url(#paint3_linear_170_11663)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.967 79.1174C112.36 85.9959 122.644 75.7499 115.755 68.3299C96.4516 49.0268 65.155 49.0268 45.8518 68.3299C42.8729 71.3088 42.8729 76.1385 45.8518 79.1174C48.8307 82.0963 53.6604 82.0963 56.6393 79.1174C69.9847 65.7719 91.6219 65.7719 104.967 79.1174Z",
    fill: "url(#paint4_linear_170_11663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_11663",
    x1: 80.5,
    y1: 9,
    x2: 80.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_11663",
    x1: 80.5,
    y1: 13,
    x2: 80.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_11663",
    x1: 80.7255,
    y1: 95.4492,
    x2: 80.7255,
    y2: 115.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_11663",
    x1: 80.8224,
    y1: 74.7529,
    x2: 80.8224,
    y2: 96.1677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_11663",
    x1: 80.8224,
    y1: 53.8525,
    x2: 80.8224,
    y2: 81.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet1);
export default __webpack_public_path__ + "static/media/no-internet1.5ec6e479e6a65bb0ee069ef66130d171.svg";
export { ForwardRef as ReactComponent };